import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
@Component({
  selector: 'app-item-tiny-gas-meter',
  template: `
    <div class="row" *ngIf="!isEditing">      
      <div class="col-md-4">
        <p class="mb-0">{{meter.name}}</p>
        <p class="mb-0"><fa-icon [icon]="faQrcode" class="me-2"></fa-icon><span class="text-muted">{{meter.meter_code}}</span></p>
      </div>
      <div class="col-md-4">
        <p class="mb-0"></p>
      </div>
      <div class="col-md-4 text-end">
        <button type="button" class="btn btn-outline-primary" (click)="startEditing()">Editar</button>
      </div>
    </div>
    <div *ngIf="isEditing">
      <app-form-gas-meter [unit_id]="unit.id" [meter]="meter" (updateMeter)="updateGasMeter($event)" (cancelMeter)="cancel()"></app-form-gas-meter>
    </div>
  `,
  styleUrls: []
})
export class ItemTinyGasMeterComponent {
  @Input() unit: any = {};
  @Input() meter: any = {};
  @Output() meterData = new EventEmitter<any>();

  faQrcode = faQrcode;

  isEditing: boolean = false;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService
  ) {}

  edit(meter: any) {
    this.meterData.emit(meter);
  }

  startEditing() {
    this.isEditing = !this.isEditing;
  }

  updateGasMeter(meter: any) {
    console.log('updateGasMeter ==> ', meter);
    this.isEditing = !this.isEditing;
    this.store.updateGasMeter(meter.id, meter).subscribe({
      next: (response: any) => {
        this.toastr.success('Medidor actualizado');
        window.location.reload();
      },
      error: (error: any) => {
        this.toastr.error('Error al actualizar el medidor');
      }
    });
    // this.meterData.emit(meter);
  }

  cancel() {
    this.isEditing = !this.isEditing;
  }

}
